export default {
    HIDE_ALL_CONTENT: -1, // 显示隐藏索引

    DEFAULT_TITLE: {
        CN: '请输入/粘贴文本',
        HK: '请输入/粘贴文本',
        EN: 'Please enter text',
        JA: 'Please enter text'
    },

    DEFAULT_DESC: {
        CN: '请输入/粘贴文本',
        HK: '请输入/粘贴文本',
        EN: 'Please enter text',
        JA: 'Please enter text'
    },

    TEXT_CLS: {
        ICON_TEXT: 'with-icon text',
        TEXT: 'text',
        ICON: 'only-icon'
    },

    ACTIVE_CLS: {
        TEXT: 'text-active',
        BORDER: 'border-active',
        TEXT_BORDER: 'text-active border-active'
    },

    CARD_SPACE: {
        DEFAULT: 20,
        OVER_4: 6
    },

    TEXT_SPACE: {
        DEFAULT: 5,
        LESS_4: 10,
        OVER_4: 0
    },

    // 左右内间距
    CARD_H_PADDING: {
        TEXT: 20,
        ICON_TEXT: 15
    },

    // eslint-disable-next-line max-len
    DEFAULT_ICON:
        'https://static.futunn.com/upload/01fego/default-icon-cce4e32725a82989402bb67b335657dc.png?_=1690787565651',
    // eslint-disable-next-line max-len
    DEFAULT_IMG:
        'https://static.futunn.com/upload/01fego/default-img-f97c894d4f918a444bfc3a882b368dac.png?_=1690787565651',

    SWIPER_TYPE: {
        IMG: 'img',
        VIDEO: 'video'
    },

    CHILD: 'basic-video',

    TEXT_OVERFLOW: {
        DEFAULT: 0,
        NO_LIMIT: 1
    },

    DIRECTION: {
        VERTICAL: 'vertical',
        HORIZONTAL: 'horizontal'
    },

    SWIPER_STYLE: {
        DEFAULT: 'default',
        RIGHT: 'right',
        BOTH: 'both'
    },

    SLIDES_PER_VIEW: {
        DEFAULT: 1,
        AUTO: 'auto'
    }
};
